import 'ga-gtag';

export default {
  send(eventName: Gtag.EventNames | string, description?: Gtag.EventParams['description']): void {
    if (window.gtag === undefined) return;
    window.gtag('event', eventName, { description });
  },
};
